// src/FormDraft.js
import './asset/App.css';
import React, { useState, useEffect, useRef  } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs'; // 导入 dayjs 库
import { useNavigate } from 'react-router-dom';
import banksData from './asset/banks.json';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import axios from 'axios';


function FormDraft() {
  const isDisabled = false;

  const [idName, setIdName] = useState('身分證字號');
  //外國人確認
  const [nationality, setNationality] = useState("");
  const [isForeigner, setIsForeigner] = useState(false);
  const [isForeignerLess183, setIsForeignerLess183] = useState(false);
  const [isForeignerOver183, setIsForeignerOver183] = useState(false);
 //EMAIL驗證
  const [emailValue, setEmailValue] = useState('');
  //ID驗證
  const [idValue, setIdValue] = useState('');
  const [idError, setIdError] = useState(false);
  //選擇申報類別
  const [categoryValue, setCategoryValue] = useState('');
  const [practiceCategoryValue, setPracticeCategoryValue] = useState('');
  const [needPracticeCategory, setNeedPracticeCategory] = useState(true);
  //是否公會
  const [insuranceFree, setInsuranceFree] = useState('');
  //是否健保
  const [healthInsurance, setHealthInsurance] = useState('');
  //上傳
  const fileVisaInputRef = useRef(null);
  const filePassportInputRef = useRef(null);
  const VisuallyHiddenInput = styled('input')`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;
  const [fileVisa, setFileVisa] = useState(null);
  const [filePassport, setFilePassport] = useState(null);
  
  //金額試算
  const [totalPrice, setTotalPrice] = useState(0);
  const [incomePrice, setIncomePrice] = useState(0);
  const [insurancePrice, setInsurancePrice] = useState(0);
  const [payPrice, setPayPrice] = useState(0);

  const [serviceValue, setServiceValue] = useState(0);
  const [dueDateValue, setDueDateValue] = useState(0);
  const [payDateValue, setPayDateValue] = useState(0);



  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [getBank, setGetBank] = useState([]);



  // 使用 useEffect 来加载 JSON 数据
  useEffect(() => {
    // 将 JSON 数据映射为下拉选项
    const bankOptions = banksData.map((bank) => (
      <MenuItem key={bank.bank_code} value={bank.name}>
        {bank.bank_code+" "+bank.name}
      </MenuItem>
    ));
    // 设置银行数据
    setBanks(bankOptions);
  }, []);

    // 使用 useEffect 监听 nationality、insuranceFree、healthInsurance 的变化
  useEffect(() => {
      // 调用 priceChange 函数，因为其中一个变量发生了变化
      priceChange();
    }, [nationality, insuranceFree, healthInsurance]);

  const [uid, setUid] = useState({});
  const [formData, setFormData] = useState({});
  let auth = true;

  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get("uid");
      // 检查 URL 中是否包含 id 参数
      if (id) {
        setUid(id);
        // 如果有 id 参数，发送 GET 请求到 API
        axios.get(`https://macct.tw/api/form/check?id=${id}`)
          .then((response) => {
            if (response.data.success) {
              // 如果成功，打印数据到控制台
              console.log(response.data);
              setFormData(response.data.form);
              setEmailValue(response.data.form.email);
              setCategoryValue(response.data.form.category);
              setPracticeCategoryValue(response.data.form.practiceCategory);
              setTotalPrice(response.data.form.price);
              setServiceValue(response.data.form.service);
              setDueDateValue(response.data.form.dueDate);
              setPayDateValue(response.data.form.payDate);
              if(response.data.form.status != "draft"){
                alert("此勞報單已完成或逾期");
                auth = false;
              }
            } else {
              // 如果不成功，重定向到 /home
              console.log(response.data);
              alert("無效的網址,"+response.data.message);
              auth = false;
            }
          })
          .catch((error) => {
            console.error('Error:', error);
            auth = false;
          });
      } else {
          // 如果 id 不存在，重定向到 /home
          alert("無效的網址");
          auth = false;
        }
  }, []);

  if(auth == false){
    return (
      <div className="App">
          <h2>聯結有誤</h2>
          <p>請重新確認連結，或是聯繫公司</p>
      </div>
    );
  }
  

  //Email validation
  function isValidEmail(emailValue) {
    const emailRule = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
    return emailRule.test(emailValue);
  }

  //ID validation
  function isValidId( idValue ) {
    if(isForeigner){
      return true;
    }
    const tab = "ABCDEFGHJKLMNPQRSTUVXYWZIO"                    
    const Ary1 = new Array (1,1,1,1,1,1,1,1,1,1,2,2,2,2,2,2,2,2,2,2,3,3,3,3,3,3 );
    const Ary2 = new Array (0,1,2,3,4,5,6,7,8,9,0,1,2,3,4,5,6,7,8,9,0,1,2,3,4,5 );
    const Mix = new Array (9,8,7,6,5,4,3,2,1,1);
   
    if ( idValue.length != 10 ) return false;
    let i = tab.indexOf( idValue.charAt(0) );
    if ( i == -1 ) return false;
    let sum = Ary1[i] + Ary2[i]*9;
   
    for ( i=1; i<10; i++ ) {
      let v = parseInt( idValue.charAt(i) );
      if ( isNaN(v) ) return false;
      sum = sum + v * Mix[i];
    }
    if ( sum % 10 != 0 ) return false;
    return true;
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log("=====================");
    console.log("event.target:"+event.target);
    console.log("event.target.value:"+event.target.value);
    /*
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    */
    //console.log(event.target);
    //console.log("name:"+name+", value:"+value);
    switch (name) {
      case 'nationality':
        if (event.target.value === '外國人在臺未滿 183 天') {
          setIsForeigner(true);
          setIsForeignerLess183(true);
          setIsForeignerOver183(false);
          setIdName('護照號碼');
        }else if(event.target.value === '外國人在臺待滿 183 天'){
          setIsForeigner(true);
          setIsForeignerLess183(false);
          setIsForeignerOver183(true);
          setIdName('護照號碼');
        } else {
          setIsForeigner(false);
          setIsForeignerLess183(false);
          setIsForeignerOver183(false);
          setIdName('身分證字號');
        }
        setNationality(value);
        //priceChange();
        break;
      case 'idNumber':
        if (!isValidId(value)) {
          setIdError(true);
        } else {
          setIdError(false);
        }
        setIdValue(value);
        break;
      case 'fileVisa':
        setFileVisa(event.target.files[0]);
        break;
      case 'filePassport':
        setFilePassport(event.target.files[0]);
        break;
      case 'category':
        setCategoryValue(value);
        if(value == "50 薪資所得" || value == "92 其他所得"){
          setNeedPracticeCategory(false);
        }else{
          setNeedPracticeCategory(true);
        }
        break;
      case 'healthInsurance':
        setHealthInsurance(value);
        //priceChange();
        break;
      case 'insurance':
        setInsuranceFree(value);
        //priceChange();
        break;
      case 'bank':
        setGetBank(value);
        break;
    }
  };




  function priceChange(){
    let tempInsurancePrice = 0;
    let tempIncomePrice = 0;
    let tempPayPrice = 0;
    console.log("insuranceFree:"+insuranceFree);
    console.log("healthInsurance:"+healthInsurance);
    
    if(isForeignerLess183 == true){ //外國人在台未滿183天
      if(categoryValue == "9B 稿費" || categoryValue == "9A 執行業務所得"){
        tempIncomePrice = Math.floor(totalPrice/5);
        if(totalPrice >= 20000 && healthInsurance == "是" && insuranceFree != "是"){
          tempInsurancePrice = Math.round( totalPrice*0.0211 );
        }else{
          tempInsurancePrice = 0;
        }
      }else if(categoryValue == "50 薪資所得"){
        if(totalPrice > 39600){
          tempIncomePrice = Math.floor(totalPrice*0.18);
        }else{
          tempIncomePrice = Math.floor(totalPrice*0.06);
        }
        if(totalPrice >= 26400 && healthInsurance == "是" && insuranceFree != "是"){
          tempInsurancePrice = Math.round( totalPrice*0.0211 );
        }else{
          tempInsurancePrice = 0;
        }
      }else if(categoryValue == "92 其他所得"){
        tempIncomePrice = Math.floor(totalPrice/5);
        tempInsurancePrice = 0;
      }
    }else{ //本國人 or 外國人在台滿183天
      if(categoryValue == "9B 稿費" || categoryValue == "9A 執行業務所得"){
        if(totalPrice >= 20010){
          tempIncomePrice = Math.floor(totalPrice/10);
        }else{
          tempIncomePrice = 0;
        }
        if(totalPrice >= 20000 && insuranceFree != "是"){
          tempInsurancePrice = Math.round( totalPrice*0.0211 );
        }else{
          tempInsurancePrice = 0;
        }
      }else if(categoryValue == "50 薪資所得"){
        if(totalPrice >= 86001){
          tempIncomePrice = Math.floor(totalPrice/20);
        }else{
          tempIncomePrice = 0;
        }
        if(totalPrice >= 26400 && insuranceFree != "是"){
          tempInsurancePrice = Math.round( totalPrice*0.0211 );
        }else{
          tempInsurancePrice = 0;
        }
      }else if(categoryValue == "92 其他所得"){
        tempIncomePrice = 0;
        tempInsurancePrice = 0;
      }
    }
    
      tempPayPrice = totalPrice-tempInsurancePrice-tempIncomePrice;
      setIncomePrice(tempIncomePrice);
      setInsurancePrice(tempInsurancePrice);
      setPayPrice(tempPayPrice);
      
      console.log(totalPrice+","+incomePrice+","+insurancePrice+","+payPrice);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    // Here you can perform your API POST request with formData
    const formData = new FormData();

    //console.log("uid:"+uid);

    formData.append("id", uid);
    formData.append("fullName", document.getElementById("fullName").value);
    formData.append("email", emailValue);
    formData.append("nationality", nationality);
    formData.append("idNumber", document.getElementById("idNumber").value);
    formData.append("address", document.getElementById("address").value);
    formData.append("phone", document.getElementById("phone").value);
    formData.append("healthInsurance", healthInsurance);
    formData.append("insurance", insuranceFree);
    formData.append("category", categoryValue);
    formData.append("practiceCategory", practiceCategoryValue);
    formData.append("price", totalPrice);
    formData.append("service", serviceValue);
    formData.append("payDate", payDateValue);
    formData.append("dueDate", dueDateValue);
    formData.append("bank", getBank);
    formData.append("bankBranch", document.getElementById("bankBranch").value);
    formData.append("bankAccount", document.getElementById("bankAccount").value);
    formData.append("accountName", document.getElementById("accountName").value);
    formData.append("incomePrice", incomePrice);
    formData.append("insurancePrice", insurancePrice);
    formData.append("payPrice", payPrice);
    formData.append("filePassport", filePassport);

    if(isForeigner && !filePassport){
      alert("未上傳護照圖片");
      return false;
    }
    if(isForeignerOver183 && !fileVisa){
      alert("未上傳居留證圖片");
      return false;
    }
    if (fileVisa !== null) {
      formData.append("fileVisa", fileVisa);
    }

    //setFormData(formData);
    //console.log(formData.get("email"));
    //console.log(formData.get("nationality"));
    //console.log(formData.get("filePassport"));
    //console.log(formData.get("fileVisa"));
    fetch('https://macct.tw/api/form/update', {
      method: 'POST',
      headers: {
        'credentials': 'include'
      },
      body: formData,
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if(data.success){
        alert("勞報單創建成功");
        navigate('/result?auth='+uid+"&confirm=yes");
      }else{
        alert("勞報單創建失敗 \n \n",data.message);
        if(data.error){
          alert("錯誤訊息 \n \n",data.error);
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });

  };


  return (
    <div className="App">
    <Typography variant="h1" sx={{ textAlign: 'left', m: 3,fontSize: '2rem' }}>新增勞報單</Typography>
    <Box>
      <Container maxWidth="md" sx={{ mt: 3 }}>
        <form id="newForm" onSubmit={handleSubmit}>
          {/* Basic Information Section */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%', margin: 'auto' }}>
            <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
              基本資料
            </Typography>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>姓名：</Typography>
            <TextField id="fullName" name="fullName" label="輸入姓名"
              variant='standard'
              required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>email：</Typography>
            <TextField id="email" name="email" label="輸入email"  variant="standard" type="email" 
                value={emailValue}
                onChange={handleInputChange}
                InputProps={{
                  readOnly: true,
                }}
                required
                />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>國籍：</Typography>
            <TextField select id="nationality" name="nationality" label="選擇國籍" labelId="nationality" sx={{ textAlign: 'left'}}
              onChange={handleInputChange} 
              variant='standard'
              required>
              <MenuItem value={"本國人"}>本國人</MenuItem>
              <MenuItem value={"本國人但未在台居住"}>本國人但未在台居住</MenuItem>
              <MenuItem value={"外國人在臺待滿 183 天"}>外國人在臺待滿 183 天</MenuItem>
              <MenuItem value={"外國人在臺未滿 183 天"}>外國人在臺未滿 183 天</MenuItem>
            </TextField>
          </div>
          {isForeigner && (
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
              <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>護照圖片：</Typography>
              <div style={{ textAlign: 'left'}}>
                <Button component="label" variant="contained"  sx={{ mt: 2}} startIcon={<CloudUploadIcon />} 
                  color="success"
                  onClick={() => filePassportInputRef.current.click()}>
                  上傳護照圖片
                </Button>
                <Typography variant="body2" sx={{ ml: 1 }} component="span">
                  {filePassport ? filePassport.name : '未選擇文件'}
                </Typography>
                <VisuallyHiddenInput id="filePassport" name="filePassport" type="file" accept=".jpg, .png, .pdf" ref={filePassportInputRef} 
                  onChange={handleInputChange}
                  />
              </div>
            </div>
          )}
          {isForeignerOver183 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
              <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>居留證圖片：</Typography>
              <div style={{ textAlign: 'left'}}>
                <Button component="label" variant="contained" sx={{ mt: 2}} startIcon={<CloudUploadIcon />} 
                  color="success"
                  onClick={() => fileVisaInputRef.current.click()}>
                  上傳居留證圖片
                </Button>
                <Typography variant="body2" sx={{ ml: 1 }} component="span">
                  {fileVisa ? fileVisa.name : '未選擇文件'}
                </Typography>
                <VisuallyHiddenInput id="fileVisa" name="fileVisa" type="file" accept=".jpg, .png, .pdf" ref={fileVisaInputRef} 
                  onChange={handleInputChange}
                  />
              </div>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{idName}：</Typography>
            <TextField id="idNumber" name="idNumber" label={`輸入${idName}`}
                value={idValue}
                onChange={handleInputChange}
                error={idError} 
                helperText={idValue && !isValidId(idValue) ? '無效的身分證' : ''} 
                variant='standard'
                required
                />
          </div>
          {isForeignerLess183 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
              <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>是否投保健保：</Typography>
              <TextField select id="healthInsurance" name="healthInsurance" label="是否投保健保" labelId="healthInsurance" sx={{ textAlign: 'left'}} 
                onChange={handleInputChange}
                variant='standard'
                required={isForeignerLess183}>
                <MenuItem value={"是"}>是</MenuItem>
                <MenuItem value={"否"}>否</MenuItem>
              </TextField>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>戶籍地址：</Typography>
            <TextField id="address" name="address" label="輸入戶籍地址" 
              variant='standard' required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>聯絡電話：</Typography>
            <TextField id="phone" name="phone" label="輸入聯絡電話"  type="number" 
              variant='standard' required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>已加入工會：</Typography>
            <TextField select id="insurance" name="insurance"  label="已加入工會" sx={{ textAlign: 'left'}} 
              onChange={handleInputChange}
              variant='standard' required>
              <MenuItem value={"否"}>否</MenuItem>
              <MenuItem value={"是"}>是</MenuItem>
            </TextField>
          </div>

          {/* Labor Data Section */}
          <Typography variant="h4" sx={{ textAlign: 'left', mt: 4, mb: 3 }}>
            勞報資料
          </Typography>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>申報類別：</Typography>
            <TextField select id="category" name="category"  label="申報類別" sx={{ textAlign: 'left'}} variant="standard" 
              value={categoryValue}
              onChange={handleInputChange} 
              InputProps={{
                readOnly: true,
              }}
              required>
              <MenuItem value={"9B 稿費"}>9B 稿費</MenuItem>
              <MenuItem value={"9A 執行業務所得"}>9A 執行業務所得</MenuItem>
              <MenuItem value={"50 薪資所得"}>50 薪資所得</MenuItem>
              <MenuItem value={"92 其他所得"}>92 其他所得</MenuItem>
            </TextField>
          </div>
          {needPracticeCategory && (
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
              <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>執行業務類別：</Typography>
              <TextField id="practiceCategory" name="practiceCategory" label="輸入執行業務類別" variant="standard" 
                value={practiceCategoryValue}
                InputProps={{
                  readOnly: true,
                }}
                required/>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>金額：</Typography>
            <TextField id="price" name="price" label="輸入金額" variant="standard" type="number" 
              value={totalPrice}
              onChange={handleInputChange} 
              InputProps={{
                readOnly: true,
              }}
            required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>試算：</Typography>
            <div>
              <Typography sx={{ textAlign: 'left',minWidth: 120, fontSize: '1rem', mt: 2 }}>所得總金額：新台幣 {totalPrice} 元</Typography>
              <Typography sx={{ textAlign: 'left',minWidth: 120, fontSize: '1rem' }}>代扣所得稅：新台幣 {incomePrice} 元</Typography>
              <Typography sx={{ textAlign: 'left',minWidth: 120, fontSize: '1rem' }}>二代健保費：新台幣 {insurancePrice} 元</Typography>
              <Typography sx={{ textAlign: 'left',minWidth: 120, fontSize: '1rem' }}>實際支付金額：新台幣 {payPrice} 元</Typography>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>勞務內容：</Typography>
            <TextField id="service" name="service" label="勞務內容" variant="standard"  
              value={serviceValue}
              InputProps={{
                readOnly: true,
              }}
              required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>給付日期：</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker label="給付日期" format="YYYY-MM-DD"
                value={dayjs(payDateValue)}
                slotProps={{
                  textField: {
                      required: true,
                      id: 'payDate'
                  }
                }}
                readOnly
                required
              />
            </LocalizationProvider>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>勞報單截止日：</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker label="勞報單截止日" format="YYYY-MM-DD"
                value={dayjs(dueDateValue)}
                slotProps={{
                  textField: {
                      required: true,
                      id: 'dueDate'
                  }
                }}
                readOnly
                required
              />
            </LocalizationProvider>
          </div>
          
          {/* Payment Data Section */}
          <Typography variant="h4" sx={{ textAlign: 'left', mt: 4, mb: 3 }}>
            支付資料
          </Typography>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>所得人銀行：</Typography>
            <TextField select id="bank" name="bank" label="所得人銀行" sx={{ textAlign: 'left'}} 
              onChange={handleInputChange}
              variant='standard'
              required>
              {banks}
            </TextField>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>銀行分行：</Typography>
            <TextField id="bankBranch" name="bankBranch" label="銀行分行"
              variant='standard' 
              required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>所得人帳號：</Typography>
            <TextField id="bankAccount" name="bankAccount" label="所得人帳號" 
              variant='standard' 
              required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>所得人戶名：</Typography>
            <TextField id="accountName" name="accountName" label="所得人戶名" 
              variant='standard'
              required/>
          </div>
          
          <Button type="submit" variant="contained" color="primary" sx={{ mt: 3 }}>
            存檔&資料送出
          </Button>
        </form>
      </Container>
    </Box>
    </div>
  );
}

export default FormDraft;